import { Component, Input } from '@angular/core';
import { FormComponentForPdf, FormInfoForPDF } from '@core/typings/pdf.typing';
import { ReferenceFieldsUI } from '@core/typings/ui/reference-fields.typing';

@Component({
    selector: 'gc-application-pdf-component',
    templateUrl: './application-pdf-component.component.html',
    standalone: false
})
export class ApplicationPDFComponentComponent {
  @Input() getFormAnswerMap: Record<number, (component: FormComponentForPdf) => any|any[]>;
  @Input() component: FormComponentForPdf;
  @Input() form: FormInfoForPDF;

  RefTypes = ReferenceFieldsUI.ReferenceFieldTypes;
}
